import { Component, ElementRef, Inject, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { empresaService } from "@api/services/empresa.service";
import { GroupService } from "@api/services/group.service";
import { loteriaEmpresaModel } from "@models/api-models/loteria_empresa.models";
import { Mygroup } from "@models/group.model";
import { Response } from "@models/Response.model";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: 'app-modal-autoingresos',
    templateUrl: './modalAutoingresos.component.html',
    styleUrls: ['./modalAutoingresos.component.scss'],
    standalone: false
})
export class ModalAutoingresosComponent {

	public autoingreso: any;

	constructor(public dialogRef: MatDialogRef<ModalAutoingresosComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { autoingreso: any },
		private groupService: GroupService,
		private toastrService: ToastrService
	) {
		this.autoingreso = data.autoingreso;
	}

	onSubmit(): void {
		this.groupService.updateAutoingreso(this.autoingreso).subscribe((res: Response<any>) => {
			if (res.status == 200) {
				this.autoingreso = res.data;
				this.dialogRef.close(this.autoingreso);
				this.toastrService.success('Ingreso Automático actualizado con éxito');
			}
			else {
				this.toastrService.error(res.u_message);
				this.dialogRef.close(this.autoingreso);
			}
		});
	}

	back() {
		this.dialogRef.close(null)
	}
}